import authenticated from './http-clients/authenticated'

export default {
  index(params) {
    let url = `/tenants/${params.tenantID}/modules?`

    if (typeof(params.paginate) !== 'undefined' && params.paginate !== null) {
      url = `${url}&paginate=${params.paginate}`
    }
    if (typeof(params.short) !== 'undefined' && params.short !== null) {
      url = `${url}&short=${params.short}`
    }
    if (typeof(params.showHidden) !== 'undefined' && params.showHidden !== null) {
      url = `${url}&show-hidden=${params.showHidden}`
    }
    if (typeof(params.active) !== 'undefined' && params.active !== null) {
      url = `${url}&active=${params.active}`
    }
    if (typeof(params.archived) !== 'undefined' && params.archived !== null) {
      url = `${url}&archived=${params.archived}`
    }
    if (typeof(params.order) !== 'undefined' && params.order !== null) {
      url = `${url}&order=${params.order}`
    }
    if (typeof(params.desc) !== 'undefined' && params.desc !== null) {
      url = `${url}&desc=${params.desc}`
    }
    if (typeof(params.search) !== 'undefined' && params.search !== null) {
      url = `${url}&search=${params.search}`
    }
    if (typeof(params.page) !== 'undefined' && params.page !== null) {
      url = `${url}&page=${params.page}`
    }

    return authenticated({
      url,
      method: 'get'
    })
  },
  show({ tenantID, moduleID }) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}`,
      method: 'get'
    })
  },
  store({ tenantID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/modules`,
      method: 'post',
      data
    })
  },
  update({ tenantID, moduleID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}`,
      method: 'post',
      data
    })
  },
  destroy({ tenantID, moduleID }) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}`,
      method: 'delete'
    })
  },
  relateMedia({ tenantID, moduleID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}/media`,
      method: 'post',
      data
    })
  },
  relateGroups({ tenantID, moduleID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}/groups`,
      method: 'post',
      data
    })
  },
  relateMembers({ tenantID, moduleID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/${moduleID}/tenant-users`,
      method: 'post',
      data
    })
  },
  hide({ tenantID, moduleID }) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/hidden/${moduleID}`,
      method: 'post'
    })
  },
  unhide({ tenantID, moduleID }) {
    return authenticated({
      url: `/tenants/${tenantID}/modules/hidden/${moduleID}`,
      method: 'delete'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/modules.js